/* eslint-disable @nx/enforce-module-boundaries */
import {
  MatSnackBar,
  MatSnackBarConfig,
  MatSnackBarDismiss,
  MatSnackBarRef,
} from '@angular/material/snack-bar';
import { SnackbarText, SnackbarType } from '@nrwl/rx-models';
import { RxSnackbarComponent } from '@nrwl/rx-snackbar';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SnackbarService {
  public snackbarText = SnackbarText;
  public snackbarType = SnackbarType;
  public defaultErrorMessage = 'Something went wrong. Please try again';

  constructor(public snackBar: MatSnackBar) {}

  public notify(text: string, i = 0): Observable<MatSnackBarDismiss> {
    const config = new MatSnackBarConfig();
    config.verticalPosition = 'top';
    config.horizontalPosition = 'center';
    config.duration = 5000;
    config.panelClass = [this.snackbarText[i].className];
    config.data = {
      text: typeof text === 'string' && text.trim() ? text : this.defaultErrorMessage,
      dismissText: this.snackbarText[i].name,
    };

    return this.snackBar.openFromComponent(RxSnackbarComponent, config).afterDismissed();
  }

  public show(text: string, className: string, duration = 5000): Observable<MatSnackBarDismiss> {
    const config = new MatSnackBarConfig();
    config.verticalPosition = 'top';
    config.horizontalPosition = 'center';
    config.duration = duration;
    config.panelClass = className + '-snackbar';
    config.data = { text };

    return this.snackBar.openFromComponent(RxSnackbarComponent, config).afterDismissed();
  }

  public success(text) {
    this.show(text, 'success');
  }

  public warning(text) {
    this.show(text, 'warning');
  }

  public error(text = this.defaultErrorMessage, duration = 10000) {
    this.show(text, 'error', duration);
  }

  public info(text, duration = 5000) {
    this.show(text, 'info', duration);
  }

  public showMessage(
    text: string,
    className: string,
    duration = 5000,
    showProgress = false,
  ): MatSnackBarRef<any> {
    const config = new MatSnackBarConfig();
    config.verticalPosition = 'top';
    config.horizontalPosition = 'center';
    config.duration = duration;
    config.panelClass = className;
    config.data = { text: text, progress: { show: showProgress, mode: 'indeterminate', perc: 0 } };

    return this.snackBar.openFromComponent(RxSnackbarComponent, config);
  }
}
